"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@react-typed-hooks/utils");

var react_1 = require("react");

function useKeyPress(_a) {
  var targetKey = _a.targetKey;

  var _b = react_1.useState(false),
      keyPressed = _b[0],
      setKeyPressed = _b[1];

  var downHandler = react_1.useCallback(function (_a) {
    var key = _a.key;

    if (key === targetKey) {
      setKeyPressed(true);
    }
  }, [targetKey]);
  var upHandler = react_1.useCallback(function (_a) {
    var key = _a.key;

    if (key === targetKey) {
      setKeyPressed(false);
    }
  }, [targetKey]);
  react_1.useEffect(function () {
    if (!utils_1.hasWindow()) {
      return;
    }

    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);
    return function () {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  }, [downHandler, upHandler]);
  return keyPressed;
}

exports.default = useKeyPress;